import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DateTimePicker from "../../Common/Controls/DatePicker/DateTimePicker";
import InputForm from "../../Common/Controls/InputForm/InputForm";
import requestAxios from "../../../util/requestAxios";
import AppContext from "../../../Context/AppContext";
import ComboBox from "../../../util/comboBox";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import "./ModalAdicion.css";

const ModalAdicion = ({ show, setShow, setCurrentRow, currentRow }) => {
  const { checkUserSession, changeLoading, contextAcreditado } =
    useContext(AppContext);
  const acreditadoInfo = contextAcreditado.getInfoAcreditado();

  const [cmbTipoGestion, setCmbTipoGestion] = useState([]);
  const [cmbTipoValoracion, setCmbValoracion] = useState([]);
  const [cmbTipoComentario, setCmbTipoComentario] = useState([]);
  const [validated, setValidated] = useState(false);
  const infoUs = checkUserSession();

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    var listTipoGestion = await ComboBox.cmbTipoGestion(infoUs);
    var listTipoValoracion = await ComboBox.cmbTipoValoracion(infoUs);
    var listTipoComentario = await ComboBox.cmbTipoComentarios(infoUs);
    setCmbTipoGestion(listTipoGestion);
    setCmbValoracion(listTipoValoracion);
    setCmbTipoComentario(listTipoComentario);
  }
  function setNewValue(field, data) {
    currentRow[field] = data;
    setCurrentRow(currentRow);
  }
  function setDateRow(date) {
    setDataRow("GesGBFechaRegistro", date);
  }
  function setDataRow(field, data) {
    debugger
    let newRow = { ...currentRow };
    newRow[field] = data;
    setCurrentRow(newRow);
  }
  async function saveData() {
    changeLoading(true);
    let errorArr = [];
    currentRow.AcreditadoId = Number(currentRow.AcreditadoId);
    currentRow.TipoGestionId = Number(currentRow.TipoGestionId);
    currentRow.ValoracionId = Number(currentRow.ValoracionId);
    currentRow.GestorId = Number(infoUs.CarGestorId);
    currentRow.Comentarios =
      currentRow.Comentarios == null ? "" : currentRow.Comentarios;
    currentRow.Comentarios =
      currentRow.TipoComentario !== ""
        ? `(${currentRow.TipoComentario}) ${currentRow.Comentarios}`
        : currentRow.Comentarios;

    if (currentRow.TipoGestionId === 0) {
      errorArr.push("Tipo de gestión");
    }
    if (currentRow.Comentarios === "") {
      errorArr.push("Comentario");
    }
    if (currentRow.ValoracionId === 0) {
      errorArr.push("Valoración");
    }
    if (errorArr.length !== 0) {
      changeLoading(false);
      const MySwal = withReactContent(Swal);
      await MySwal.fire({
        title: <strong>Error!</strong>,
        html: (
          <i>
            Es necesario capturar: <br />
            <b>{errorArr.join(", ")}</b>
          </i>
        ),
        icon: "warning",
      });
    }

    if (errorArr.length === 0) {
      const { error, data } = await requestAxios({
        url: `Acreditados/${
          currentRow.GestionId !== 0 ? "UGestionMensual" : "IGestionMensual"
        }`,
        method: currentRow.GestionId !== 0 ? "put" : "post",
        token: infoUs.bearer_token,
        data: currentRow,
      });
      if (error === "") {
        changeLoading(false);
        const MySwal = withReactContent(Swal);
        await MySwal.fire({
          title: <strong>Hecho!</strong>,
          html: <i>Guardado con éxito!</i>,
          icon: "success",
        });
        window.location.reload();
      } else {
        alert("Error, try again");
      }
    }
    changeLoading(false);
  }
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    // if (form.checkValidity() === true) {
    saveData();
    // }
  };
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="AcreditadoDetalleModalTitle">
          {currentRow.GestionId == 0 ? "Registrar nueva" : "Editar"} gestión al
          acreditado
          <h2>Rellene los campos y pulse guardar</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modalAdicion__nombrecontainer">
          <div>
            Num. Expediente: <h1>{acreditadoInfo.AcreditadoId}</h1>
          </div>
          <div>
            Nombre: <h1>{acreditadoInfo.Nombreac}</h1>
          </div>
        </div>
        <Form
          
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <div className={`modalAdicion__bodycontainer ${currentRow.GestionId == 0 ? "" : "NoEditar"} `}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Tipo de gestión
              </InputLabel>
              <Select
                required
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={
                  <div className="cmbTipoGestionTitle">Tipo de gestión</div>
                }
                onChange={(input) =>
                  setDataRow("TipoGestionId", input.target.value)
                }
                value={currentRow.TipoGestionId}
              >
                {cmbTipoGestion.map((item) => (
                  <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <DateTimePicker
              required
              dateValue={currentRow.GesGBFechaRegistro}
              setDateValue={setDateRow}
              disabled={true}
            />
          </div>
          <div className={`modalAdicion__bodycontainer2  ${currentRow.GestionId == 0 ? "" : "NoEditar"}`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Seleccione los comentarios si quiere agregarlos al comentario
              </InputLabel>
              <Select
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={
                  <div className="cmbTipoGestionTitle">
                    Seleccione los comentarios si quiere agregarlos al
                    comentario
                  </div>
                }
                onChange={(input) => {
                  setDataRow("TipoComentario", input.target.value);
                }}
                value={currentRow.TipoComentario}
              >
                {cmbTipoComentario.map((item) => (
                  <MenuItem className="cmbTipoComentario_Item" value={item.Id}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            Comentario
            <InputForm
              field="Comentarios"
              Row={currentRow}
              setNewValue={setDataRow}
              as="textarea"
              required={true}
            />
            <br />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Valoración</InputLabel>
              <Select
                className="cmbTipoGestion"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={currentRow.ValoracionId}
                label={<div className="cmbTipoGestionTitle">Valoración</div>}
                onChange={(input) =>
                  setDataRow("ValoracionId", input.target.value)
                }
              >
                {cmbTipoValoracion.map((item) => (
                  <MenuItem className="cmbTipoGestion_Item" value={item.Id}>
                    {item.Text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="modalAdicion__buttoncontainer">
            <button
              className="modalAdicion__btnCancelar"
              type="button"
              onClick={() => setShow(false)}
            >
              Cancelar
            </button>
            {currentRow.GestionId === 0 && (
              <button
                className="modalAdicion__btnRegistrar"
                onClick={() => console.log(currentRow)}
                type="submit"
              >
                Registrar
              </button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAdicion;
